import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';
import { cn } from '@/lib/utils';

export interface OptionButtonGroupOption<T extends string> {
  value: T;
  label: string;
}

export interface OptionButtonGroupProps<T extends string> {
  value: T;
  options: readonly OptionButtonGroupOption<T>[];
  onChange: (value: T) => void;
  ariaLabel: string;
  className?: string;
}

export function OptionButtonGroup<T extends string>({
  value,
  options,
  onChange,
  ariaLabel,
  className,
}: OptionButtonGroupProps<T>) {
  return (
    <ButtonGroup
      aria-label={ariaLabel}
      className={cn('[&_button]:py-1.5 [&_button]:h-auto', className)}
    >
      {options.map((option) => {
        const isActive = value === option.value;

        return (
          <Button
            key={option.value}
            type="button"
            variant={isActive ? 'default' : 'outline'}
            onClick={() => onChange(option.value)}
            aria-label={option.label}
            aria-pressed={isActive}
          >
            {option.label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
}
